import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { GetApp } from "@mui/icons-material";
import SharedMaterialReactTable, { ISharedTableColumn } from "../../../Shared/MaterialReactTable";

export function renderAllDownloadsTable(data, downloadFunc, classes) {
    // Transform array data to objects with proper property names
    const transformedData = data.map(item => ({
        Name: item[0],           // displayName
        Date: item[1],           // uploadDay + uploadTime
        User: item[2],           // uploadUser
        key: item[3],            // download key
        isArchived: item[4]      // archived flag
    }));

    // SharedMaterialReactTable columns definition
    const getTableColumns = (): ISharedTableColumn<any>[] => [
        {
            accessorKey: 'Name',
            header: 'Name',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'Date',
            header: 'Date',
            enableSorting: true,
            enableFiltering: false,
        },
        {
            accessorKey: 'User',
            header: 'User',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'download',
            header: '',
            enableSorting: false,
            enableFiltering: false,
            size: 75,
            Cell: ({ row }) => (
                <Tooltip title="Download File" aria-label="Download File">
                    <IconButton onClick={() => downloadFunc(row.original.key)}>
                        <GetApp />
                    </IconButton>
                </Tooltip>
            ),
        }
    ];

    return (
        <SharedMaterialReactTable
            data={transformedData}
            columns={getTableColumns()}
            title="All Downloads"
            isLoading={false}
            enablePagination={true}
            enableSorting={true}
            enableFiltering={true}
            enableColumnActions={true}
            enableRowActions={false}
            initialState={{
                pagination: { pageIndex: 0, pageSize: 15 },
            }}
            muiPaginationProps={{
                rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
            }}
            emptyMessage="No downloads found."
        />
    );
}

